import { getCookieValue } from '@naturehouse/nh-essentials/lib/cookies/cookie';

const PREFIX = '_nhft_';

export enum DeploymentEnvironment {
    DEV = 'dev',
    PROD = 'prod'
}

export enum FeatureToggle {
    TRANSLATIONS = 'translations',
    OPEN_GDS_ONBOARDING = 'open-gds-onboarding',
    NEW_CALENDAR = 'new-calendar',
    SEARCH_GROUP_LOCATIONS = 'search-group-locations',
    SEARCH_LOWEST_PRICE = 'search-lowest-price',
    GENERAL_SCORE_FIVE_SCALE = 'general-score-five-scale'
}

export function isFeatureEnabled(name: string): boolean {
    const cookieValue = getCookieValue(PREFIX + name);
    return cookieValue === 'true';
}
